export class HeaderAction {
    constructor(public id: string | number, public icon: string) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/header-action.ts